import { defineKind } from "./base";

/** YouTube (video, music.youtube) in the hosted player. Old items may carry only the video id. */
export const youtube = defineKind({
  id: "youtube",
  provider: "youtube",
  types: ["YOUTUBE"],
  surface: "embed",
  icon: "play",
  caps: {
    seekable: true, endsByItself: true, heldWhenHidden: true, castable: true, queueable: true,
    dockable: true, fullScreen: true, ownControls: true, nothingOver: true,
  },
  label: (t) => t("cast_item_youtube", "YouTube"),
  meta: (t) => t("wall_provider_youtube", "YouTube"),
  playUrl: (item) => item.url || (item.externalId ? `https://www.youtube.com/watch?v=${item.externalId}` : null),
  // room-stc SnapshotItems keeps a YouTube item only with its video id.
  queueReady: (item) => item.externalId != null && item.externalId !== "",
  slot: { mediaType: "YOUTUBE", fallback: true, defaultFallback: true, videoIdOnSlot: true },
});
